"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseQuestion = _interopRequireDefault(require("./BaseQuestion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class RangeQuestion extends _BaseQuestion.default {
  updateMetaData() {
    var _this$question, _this$question$rangeC, _this$question$rangeC2;
    const selectedRangeChoice = (_this$question = this.question) === null || _this$question === void 0 ? void 0 : (_this$question$rangeC = _this$question.rangeChoices) === null || _this$question$rangeC === void 0 ? void 0 : (_this$question$rangeC2 = _this$question$rangeC.labels) === null || _this$question$rangeC2 === void 0 ? void 0 : _this$question$rangeC2.find(label => {
      return label.value === this.selections[0];
    });
    const selectedRangeChoiceEnable = (selectedRangeChoice === null || selectedRangeChoice === void 0 ? void 0 : selectedRangeChoice.enable) || [];
    this.handleFlags([...selectedRangeChoiceEnable, ...(this.question.enable || [])], this.selections[0]);
    const {
      characteristics,
      recommendationCategories
    } = this.question;
    selectedRangeChoice ? this.handleCharacteristics([{
      ...(characteristics === null || characteristics === void 0 ? void 0 : characteristics[0]),
      ...selectedRangeChoice
    }]) : this.handleCharacteristics(characteristics);
    this.handleRecommendationCategories(recommendationCategories);
    return this.metadata;
  }
  handleWeights(characteristic, category) {
    var _this$question2, _this$question2$range, _this$question2$range2, _this$question2$range3, _this$metadata$catego;
    const characteristicWeight = ((_this$question2 = this.question) === null || _this$question2 === void 0 ? void 0 : (_this$question2$range = _this$question2.rangeChoices) === null || _this$question2$range === void 0 ? void 0 : (_this$question2$range2 = _this$question2$range.labels) === null || _this$question2$range2 === void 0 ? void 0 : (_this$question2$range3 = _this$question2$range2.find(el => el.value === this.selections[0])) === null || _this$question2$range3 === void 0 ? void 0 : _this$question2$range3.weight) || characteristic.weight;
    if (characteristicWeight === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    this.checkCategory(category);
    this.metadata[category].weights[characteristicName] = this.getValue(characteristicWeight) + (this.getIsCumulative() ? (_this$metadata$catego = this.metadata[category].weights[characteristicName]) !== null && _this$metadata$catego !== void 0 ? _this$metadata$catego : 0 : 0);
  }
  handleTargetPoints(characteristic, category) {
    var _this$question3, _this$question3$range, _this$question3$range2, _this$question3$range3, _this$metadata$catego2;
    const characteristicTargetPoint = ((_this$question3 = this.question) === null || _this$question3 === void 0 ? void 0 : (_this$question3$range = _this$question3.rangeChoices) === null || _this$question3$range === void 0 ? void 0 : (_this$question3$range2 = _this$question3$range.labels) === null || _this$question3$range2 === void 0 ? void 0 : (_this$question3$range3 = _this$question3$range2.find(el => el.value === this.selections[0])) === null || _this$question3$range3 === void 0 ? void 0 : _this$question3$range3.targetPoint) || characteristic.targetPoint;
    if (characteristicTargetPoint === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    this.checkCategory(category);
    this.metadata[category].targetPoints[characteristicName] = Math.min(Math.round((this.getValue(characteristicTargetPoint) + (this.getIsCumulative() ? (_this$metadata$catego2 = this.metadata[category].targetPoints[characteristicName]) !== null && _this$metadata$catego2 !== void 0 ? _this$metadata$catego2 : 0 : 0)) * 100) / 100, 1);
  }
}
exports.default = RangeQuestion;